/**
 * @ngdoc service
 * @name manager.api.Accounts
 *
 */

import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const actions = {
    getUndoCancellationNotification: {
        method: 'GET',
        url: `${BASE_PATH_API}/account/undoCancellationNotification`
    },
    getManagedPropertyTypes: {
        method: 'GET',
        url: `${BASE_PATH_API}/account/managedPropertyTypes`
    },
    getAccountState: {
        method: 'GET',
        url: `${BASE_PATH_API}/account/state`,
        cache: true
    },
    getAccountId: {
        method: 'GET',
        url: `${BASE_PATH_API}/account/id`,
        cache: true
    },
    saveCompanyInformation: {
        method: 'PUT',
        url: `${BASE_PATH_API}/account/company`
    },
    saveCompanyAddress: {
        method: 'PUT',
        url: `${BASE_PATH_API}/account/companyAddress`
    },
    saveFiles: {
        method: 'POST',
        url: `${BASE_PATH_API}/account/files`,
        isArray: true
    },
    addAccountDetails: {
        method: 'PUT',
        url: `${BASE_PATH_API}/account/initialSetup`
    },
    getSubscriptionPlanType: {
        method: 'GET',
        url: `${BASE_PATH_API}/account/subscriptionPlanType`,
    },
    getDefaultCountryId: {
        method: 'GET',
        url: `${BASE_PATH_API}/account/defaultCountryId`
    },
    getCompanyInfo: {
        method: 'GET',
        url: `${BASE_PATH_API}/account/companyInfo`
    },
    isUseAccountSummariesActive: {
        method: 'GET',
        url: `${BASE_PATH_API}/account/accountSummariesStatus`
    },
    cancellationReasons: {
        method: 'GET',
        url: `${BASE_PATH_API}/account/cancellationReasons`
    },
    doesAccountHavePendingUserPayments: {
        method: 'GET',
        url: `${BASE_PATH_API}/account/doesAccountHavePendingUserPayments`
    },
    accountCancellation: {
        method: 'POST',
        url: `${BASE_PATH_API}/account/accountCancellation`
    },
    undoAccountCancellation: {
        method: 'PUT',
        url: `${BASE_PATH_API}/account/undoAccountCancellation`
    },
    getRentalsActivity: {
        method: 'GET',
        url: `${BASE_PATH_API}/account/activity/rentals`
    },
    getAssociationsActivity: {
        method: 'GET',
        url: `${BASE_PATH_API}/account/activity/associations`
    },
    getWebAddress: {
        method: 'GET',
        url: `${BASE_PATH_API}/account/webAddress`
    },
    setWebAddress: {
        method: 'PUT',
        url: `${BASE_PATH_API}/account/webAddress`
    },
    getWebAddressIsValid: {
        method: 'GET',
        url: `${BASE_PATH_API}/account/webAddress/validation/:address`
    },
    getTermsOfUse: {
        method: 'GET',
        url: `${BASE_PATH_API}/account/termsOfUse`
    },
    getAccountAnalytics: {
        method: 'GET',
        url: `${BASE_PATH_API}/account/analytics`,
        cache: true
    },
    getAnalyticsData: {
        method: 'GET',
        url: `${BASE_PATH_API}/account/analyticsData`,
        cache: true
    },
    subscriptionManagementEligibility: {
        method: 'GET',
        url: `${BASE_PATH_API}/account/subscriptionManagement/accountEligibility`
    },
    doesAccountHaveActiveRentReportingSubscriptions: {
        method: 'GET',
        url: `${BASE_PATH_API}/account/doesAccountHaveActiveRentReportingSubscriptions`
    }
};

export function AccountApi() {
    return createActions(actions);
}
